import {Component, DestroyRef, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ErrorModule} from "@app/error/error.module";
import {FilterModule} from "@app/filter/filter.module";
import {MedIconResetModule} from "@mk/med-icons";
import {MedPaginationModule} from "@med-ui/med-pagination/med-pagination.module";
import {NgForOf, NgIf} from "@angular/common";
import {TooltipModule} from "@app/tooltip/tooltip.module";
import {ReddistributionFilterKeys} from "@app/filter/filter.service";
import {QuarantineApiService} from "@app/quarantine/services/quarantine.api.service";
import {
  QuarantineDocumentPlacement,
  QuarantineDocumentsPlacementRequestInterface,
  QuarantineDocumentsPlacementResponce
} from "@app/quarantine/intrfaces/quarantine.interface";
import {GroupByPipe} from "@app/quarantine/shared/pipes/group-by/group-by.pipe";
import {DocumentTypeInterfaces} from "@app/quarantine/intrfaces/quarantine-form.interface";
import {DocumentStatusHighlightDirective} from "@app/quarantine/shared/directives/status-hilight.directive";
import {DataService} from "@app/shared/data.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {TokenInterface} from "@app/Interfaces/token.interface";
import {jwtDecode} from "jwt-decode";
import {ContextMenuComponent} from "@app/context-menu/context-menu.component";
import {Router} from "@angular/router";
import {HelpersQuarantineService} from "@app/quarantine/services/helpers.service.service";
import {
  NoWrapStringWrapperComponent
} from "@app/quarantine/shared/no-wrap-string-wrapper/no-wrap-string-wrapper.component";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {catchError, debounceTime, Subject, tap} from "rxjs";

@Component({
  selector: 'app-quarantine-table',
  templateUrl: './quarantine-table.component.html',
  styleUrls: ['./quarantine-table.component.scss'],
  standalone: true,
  imports: [
    ErrorModule,
    FilterModule,
    MedIconResetModule,
    MedPaginationModule,
    NgForOf,
    NgIf,
    TooltipModule,
    GroupByPipe,
    DocumentStatusHighlightDirective,
    NoWrapStringWrapperComponent,
    LoadingAnimationComponent
  ]
})
export class QuarantineTableComponent implements OnInit, OnDestroy {
  constructor(
      private quarantineApiService: QuarantineApiService,
      private dataService: DataService,
      private  router: Router,
      private helpersQuarantineService: HelpersQuarantineService
  ) {
  
  }
  
  onTableScroll () {
  
  }
  
  ngOnInit() {
    this.subscribeToSubject();
    
    this.dataService.showMyOrganizationValue
        .pipe(
            takeUntilDestroyed(this.destroyRef)
        )
        .subscribe((value) => {
          if (value) {
            this.filters = {
              ...this.filters,
              organizationId: [this.token.organizationInfo.organizationId]
            }
          } else {
            delete this.filters.organizationId;
            this.filters = {
              ...this.filters
            }
          }
          if(!this.resetFilters) {
            this.pagination.page = 1;
            this.$emitRequest.next({})
          }
        });
    
    this.getDocumentTypes();
    this.getOrganisationTypes()
  }
  
  ngOnDestroy() {
    this.$emitRequest.complete();
  }
  
  destroyRef = inject(DestroyRef);
  
  documents: QuarantineDocumentPlacement[] = [];
  token: TokenInterface = jwtDecode(localStorage['access_token']);
  filters: QuarantineDocumentsPlacementRequestInterface = {};
  errorCode: number | null = null;
  
  @ViewChild('contextMenu') contextMenu!: ContextMenuComponent;
  
  pagination = {
    page: 1,
    perPage: 20,
    totalPages: 0,
    totalElements: 0
  }
  
  resetFilters: boolean = false;
  
  isLoading = false;
  
  $emitRequest = new Subject();
  
  filterCount = 0;
  
  documentTypes: { [key: string]: string } = {};
  organisationTypes:{ [key: string]: string } = {};
  statusTypes:{ [key: string]: string } = this.helpersQuarantineService.statusTypes;
  placementTypes:{ [key: string]: string } = this.helpersQuarantineService.placementTypes;


  
  protected readonly filterKeys = ReddistributionFilterKeys;
  protected readonly Object = Object;
  
  getQuarantinePlacements() {
    this.isLoading = true;
    this.quarantineApiService.getQuarantinePlacements(this.filters, {page:  this.pagination.page - 1, size: this.pagination.perPage})
        .pipe(
            catchError(err => {
              this.errorCode = err.status;
              this.isLoading = false;
              return [];
            })
        )
        .subscribe((data: QuarantineDocumentsPlacementResponce) => {
          this.errorCode = null;
          this.documents = data.content;
          this.pagination.totalPages = data.totalPages;
          this.pagination.totalElements = data.totalElements;
          this.isLoading = false;
        })
  }
  
  getDocumentTypes () {
    this.quarantineApiService.getDocumentTypes()
    .subscribe((data: DocumentTypeInterfaces) => {
      data.forEach((doc) => {
        this.documentTypes[doc.name] = doc.nameUa;
      });
    })
  }
  
  getOrganisationTypes () {
    this.quarantineApiService.getOrganizationTypes()
    .subscribe((data: DocumentTypeInterfaces) => {
      data.forEach((doc) => {
        this.organisationTypes[doc.name] = doc.nameUa;
      });
    })
  }
  
  onResetFilters() {
    this.resetFilters = true;
    setTimeout(() => {
      this.resetFilters = false;
    }, 1000);
    this.filters = {};
    this.pagination.page = 1;
    this.dataService.showMyOrganization = false;
    this.$emitRequest.next({});
  }
  
  onPageChange(page: number) {
    this.pagination.page = page;
    this.$emitRequest.next({});
  }
  
  applyFilters(data: {key: string, payload: string[] | {[p: string]: any}}) {
    this.pagination.page = 1;
    if(this.resetFilters) {
      return;
    }
    if (data.key === 'series') {
      // @ts-ignore
      if (data.payload && data.payload[0].length > 0) {
        this.filters = {
          ...this.filters,
          // @ts-ignore
          [data.key]: data.payload
        }
      } else {
        // @ts-ignore
        delete this.filters[data.key];
        this.filters = {
          ...this.filters
        }
      }
      this.$emitRequest.next({});
      return;
    }
    
    if (data.payload.length > 0) {
      this.filters = {
        ...this.filters,
        // @ts-ignore
        [data.key]: data.payload
      }
    } else {
      // @ts-ignore
      delete this.filters[data.key];
      this.filters = {
        ...this.filters
      }
    }
    this.$emitRequest.next({});
  }
  
  onRowClick(event: MouseEvent, row: any): void {
    event.stopImmediatePropagation();

    if (row.transactionType === 'QUARANTINE_PLACEMENT') {
      this.router.navigate(
          ['quarantine/edit-quarantine-placement'], {
            state :  {
              quarantinePlacement: row
            }
          }
      )
    } else {
      this.router.navigate(
          ['quarantine/edit-quarantine-removal'], {
            state :  {
              quarantinePlacement: row
            }
          }
      )
    }
  }
  
  subscribeToSubject() {
    this.$emitRequest
        .pipe(
            takeUntilDestroyed(this.destroyRef),
            debounceTime(400),
            tap(() => {
              this.filterCount = Object.keys(this.filters).length;
            })
        )
        .subscribe(() => {
          this.getQuarantinePlacements();
        });
  }
  
}
